// extracted by mini-css-extract-plugin
module.exports = {"abas":"Abas_abas__1cmU_","aba":"Abas_aba__2pPYn","icone":"Abas_icone__33_MD","ativo":"Abas_ativo__34FF8"};